import { InAppState } from "../base/InAppState";
import template from "./InstallTemplate.html";

import { _lcs } from "../../i18n";

/**
 * InstallState — "App installieren" (`/install`): why to install, and how.
 *
 * The guest normally lands here from iOS only (see Pwa.install): Chromium has
 * an install dialog of its own and the menu opens that directly, but iOS has
 * no API at all, just three taps through Safari's menus — which is what this
 * page walks through. Opened any other way, it shows what fits the device:
 *
 *   • "prompt"      → a button that opens the browser's install dialog
 *   • "ios"         → the step-by-step instructions
 *   • "installed"   → nothing left to do
 *   • "unsupported" → which browser to open the page in instead
 *
 * Re-rendered on "pwa-change", so installing from the button turns the page
 * into its "installed" state (Pwa's `appinstalled` handler brings the toast).
 */
export class InstallState extends InAppState
{
    static ROUTE = "/install";
    static ID = "install";

    showsBottomNav() { return false; }

    async enter()
    {
        this.render();
        this.addEventListener( this.app, "pwa-change", () => this.render() );
    }

    render()
    {
        if ( !this.isActive() )
        {
            return;
        }

        this.renderScreen( template, {
            mode : this._mode(),
            house : this.app.accommodation?.name || "BELTURO"
        } );

        this._on( "back", () => this.app.router.redirect( "/" ) );
        this._on( "done", () => this.app.router.redirect( "/" ) );
        this._on( "install", () => this.app.pwa.install() );
    }

    _mode()
    {
        const pwa = this.app.pwa;
        if ( pwa.isInstalled() )
        {
            return "installed";
        }
        return pwa.installMode() || "unsupported";
    }

    _on( id, handler )
    {
        const el = this.app.view.pageContent.querySelector( '[data-id="' + id + '"]' );
        if ( el ) this.addEventListener( el, "click", handler );
    }
}
